<template>
  <div>
    <ui-card
      :is-loading="isLoading"
      class="overview-card h-100"
    >
      <div class="card-header overview-card__header mb-4 pb-2">
        <ui-icon name="best-performers" size="32px" />
        <h4 class="card-title overview-card__title">
          Best performers
        </h4>
      </div>
      <template v-if="previewPerformers.length">
        <div
          v-for="item in previewPerformers"
          :key="item.id"
          class="d-flex justify-content-between mt-3"
        >
          <router-link
            :to="{ name: 'location-view', params: { locationId: item.id }}"
            class="card-label overview-card__label"
          >
            {{ item.name }}
          </router-link>
          <div class="card-value">
            {{ item.amount | money(item.currency) }}
          </div>
        </div>
      </template>
      <span v-else class="text-gray">
        {{ $t('noData') }}
      </span>

      <template #footer>
        <stats-best-performers-modal
          v-if="statsPerformers.length > previewCount"
          :performers="statsPerformers"
        >
          <template #activator="{ open }">
            <ui-button
              link
              type="primary"
              @click="open"
            >
              {{ $t('form.buttons.viewAll') }}
            </ui-button>
          </template>
        </stats-best-performers-modal>
      </template>
    </ui-card>
  </div>
</template>

<script>
import api from '@/api';
import StatsBestPerformersModal from './StatsBestPerformersModal.vue';
import StatsMixin from './StatsMixin';

export default {

  mixins: [
    StatsMixin,
  ],

  components: {
    StatsBestPerformersModal,
  },

  data: () => ({
    items: [],
    previewCount: 3,
  }),

  computed: {
    statsPerformers() {
      return this.items
        .map(({ totalAmountTips, workplace }) => {
          return {
            id: workplace.id,
            name: workplace.name,
            amount: totalAmountTips.amount,
            currency: totalAmountTips.currency,
          };
        });
    },
    previewPerformers() {
      return this.statsPerformers.slice(0, this.previewCount);
    },
  },

  methods: {
    async load() {
      const { data } = await api.locations.getBestPerformers({
        salesId: this.staffId,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      });

      if (data) {
        this.items = data;
      }
    },
  },
};
</script>
